import axios from 'axios';
import { useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { useQuery } from 'react-query';
import React, { useEffect, useState } from 'react';
import cn from 'classnames';
import ReactInputVerificationCode from 'react-input-verification-code';

import { login } from '../../../../actions/loginForms';
import styles from '../styles.scss';
import { ROOT_URL } from '../../../../constants/Config';
import Timer from '../Timer';
import { Button } from '../../Button';
import { sendPhone, Types } from '../common';

const sendCode = async ({ phone, code, type }) => {
  const url = type === Types.Call ? `${ROOT_URL}/calls/checkpin ` : `${ROOT_URL}/user/sms/login`;

  try {
    const response = await axios.post(url, {
      phone: phone.match(/\d+/g).join(''),
      [type === Types.Call ? 'pin' : 'code']: code,
      platform: 'web'
    });

    return response.data.data;
  } catch (error) {
    return Promise.reject(error.response.data.error['error-code']);
  }
};

export const Code = ({ phone, type, goToPhoneStep }) => {
  const [code, setCode] = useState('');
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const [isResending, setIsResending] = useState(false);
  const { data, error: codeError, isLoading: isLoadingCode, refetch: postCode } = useQuery(['code', { phone, code, type, isResending }],
    () => sendCode({ phone, code, type }), {
      enabled: false,
      retry: 0,
      onError: (error) => {
        if (error === 'ERROR_INVALID_PIN' || error === 'USER_NOT_FOUND') {
          setTimeout(() => {
            try {
              setCode('');
            } catch (e) {

            }
          }, 7000);
        }
      }
    });

  useEffect(() => {
    if (!data) {
      return;
    }

    dispatch(login(data));
  }, [data]);

  const getError = (error) => {
    if (!error) {
      return null;
    }

    if (error === 'USER_NOT_FOUND') {
      return t('containers.logIn.error-code-sms');
    }

    if (error === 'ERROR_INVALID_PIN') {
      return t('containers.logIn.error-code-phone');
    }

    return t('components.login.formNumber.serverError');
  };

  const handleReset = () => {
    setIsResending(true);
    return sendPhone({ phone, type }).finally(() => {
      setIsResending(false);
    });
  };
  const error = getError(codeError);

  useEffect(() => {
    const handleEnter = (e) => {
      if (e.key !== 'Enter') {
        return;
      }

      if (isLoadingCode) {
        return;
      }

      if (isResending) {
        return;
      }

      const isValid = code.length === (type === Types.Call ? 4 : 5);

      if (!isValid) {
        return;
      }

      postCode();
    };

    document.addEventListener('keypress', handleEnter);

    return () => {
      document.removeEventListener('keypress', handleEnter);
    };
  }, [code, isResending, isLoadingCode]);

  return (<React.Fragment>
    <div
      className={cn(styles.CodeInputContainer, {
        [styles.CodeInputContainerPhone]: type === Types.Call,
        [styles.CodeInputContainerSMS]: type === Types.Sms,
        [styles.CodeInputContainerError]: !!error
      })}
    >
      <ReactInputVerificationCode
        autoFocus
        length={type === Types.Call ? 4 : 5}
        placeholder=""
        value={code}
        onChange={setCode}
      />
    </div>
    <div
      className={cn(styles.LoginFormHint, {
        [styles.LoginFormHintError]: error
      })}
      dangerouslySetInnerHTML={{ __html: error || t(`containers.logIn.hint-code-${type}`) }}
    />
    <Timer
      textLocale={type === Types.Call ? 'containers.logIn.recall' : 'containers.logIn.resend'}
      resetLocale={type === Types.Call ? 'containers.logIn.doRecall' : 'containers.logIn.doResend'}
      secondsLimit={60}
      onReset={handleReset}
    />
    <div className={styles.LoginFormButtons}>
      <Button
        onClick={postCode}
        isPrimary
        isLoading={isLoadingCode}
        isDisabled={!code || code.length < (type === Types.Call ? 4 : 5) || isResending}
      >
        {t('containers.logIn.buttons.enter')}
      </Button>

      <Button isDisabled={isLoadingCode} onClick={goToPhoneStep}>
        {t('containers.logIn.buttons.back')}
      </Button>
    </div>
  </React.Fragment>);
};



// WEBPACK FOOTER //
// ./src/containers/Login/Form/Code/index.js